import { AlpineComponent } from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

type QuoteData = {}

export default ():AlpineComponent<QuoteData> => ({
  init() {
    const swiperEl = this.$root.querySelector('.swiper') as HTMLElement;

    if (!swiperEl) {
      return;
    }

    new Swiper(swiperEl, {
      speed: 1000,
      loop: true,
      spaceBetween: 2,
      threshold: 10,
      centerInsufficientSlides: true,
      watchOverflow: true,
      followFinger: true,
      updateOnWindowResize: true,
      modules: [Navigation, Pagination],
      navigation: {
        prevEl: this.$root.querySelector('.ce-quote-btn--prev') as HTMLElement,
        nextEl: this.$root.querySelector('.ce-quote-btn--next') as HTMLElement,
      },
      pagination: {
        el: '.ce-quote-pagination',
        clickable: true,
      },
      on: {
        slidesLengthChange: () => {
          this.$lazyLoad.update();
        },
      }
    });
  },
});
